import { render, staticRenderFns } from "./ValuePassUnitsTrxn.vue?vue&type=template&id=29697364&"
import script from "./ValuePassUnitsTrxn.vue?vue&type=script&lang=js&"
export * from "./ValuePassUnitsTrxn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports